var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.dialogVisible,
              expression: "!dialogVisible"
            }
          ],
          staticClass: "info-all"
        },
        [
          _c(
            "el-aside",
            {
              staticClass: "aside-left",
              style: { height: _vm.boxHeight },
              attrs: { width: "2.80rem" }
            },
            [
              _c("p", { staticClass: "page-total" }, [
                _c("span", { staticClass: "tit" }, [_vm._v("签署文件列表")]),
                _c("span", [_vm._v("共" + _vm._s(_vm.fileList.length) + "个")])
              ]),
              _c(
                "div",
                { staticClass: "page-con" },
                [
                  _vm._l(_vm.fileList, function(file, i) {
                    return [
                      _c(
                        "div",
                        {
                          key: i,
                          staticClass: "list",
                          class: _vm.checkAct === i ? "active" : "",
                          on: {
                            click: function($event) {
                              return _vm.chooseFile(file, i)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "bx" }, [
                            _c("img", { attrs: { src: _vm.fileIcon(file) } })
                          ]),
                          _c(
                            "p",
                            {
                              staticClass: "title",
                              attrs: { title: file.fileName }
                            },
                            [_vm._v(_vm._s(file.fileName))]
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          ),
          _c("transition", { attrs: { name: "el-fade-in" } }, [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.drawerShow,
                  expression: "drawerShow"
                }
              ],
              staticClass: "aside",
              style: { height: _vm.boxHeight }
            })
          ]),
          _c("transition", { attrs: { name: "my" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.drawerShow,
                    expression: "drawerShow"
                  }
                ],
                staticClass: "aside-content",
                style: { height: _vm.boxHeight }
              },
              [
                _c("div", { staticClass: "aside-top" }, [
                  _vm._v(
                    "\n          仅供参与方查阅，不用于签署（共\n          " +
                      _vm._s(this.enclosureFilesList.length) +
                      " 份）\n          "
                  ),
                  _c("span", {
                    staticClass: "el-icon-error",
                    on: {
                      click: function($event) {
                        _vm.drawerShow = false
                      }
                    }
                  })
                ]),
                _c(
                  "div",
                  {
                    staticClass: "aside-box",
                    style: { height: _vm.windowHeight - 120 + "px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "enclosure-box" },
                      _vm._l(_vm.enclosureFilesList, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "enclosure-item" },
                          [
                            _c("div", { staticClass: "li-preview" }, [
                              _vm.isImg(item) || _vm.isVideo(item)
                                ? _c("span", {
                                    staticClass: "el-icon-view",
                                    attrs: { title: "预览" },
                                    on: {
                                      click: function($event) {
                                        return _vm.previewVideOrImg(item)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm.isDoc(item)
                                ? _c("span", {
                                    staticClass: "el-icon-view",
                                    attrs: { title: "预览" },
                                    on: {
                                      click: function($event) {
                                        return _vm.previewDoc(item)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.downloadAttatchFile(item),
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "el-icon-download",
                                    attrs: { title: "下载" }
                                  })
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "li-con" }, [
                              _c("div", { staticClass: "t-do" }, [
                                _vm._v(_vm._s(_vm.getEnclosureSuffix(item)))
                              ]),
                              _c("h1", { attrs: { title: item.fileName } }, [
                                _vm._v(_vm._s(item.fileName))
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _vm.enclosureFilesList.length === 0
                      ? _c("no-data", {
                          attrs: { slot: "empty", text: "暂无数据" },
                          slot: "empty"
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "aside-tab",
              class: _vm.drawerShow ? "open" : "close"
            },
            [
              _c(
                "div",
                {
                  staticClass: "tab",
                  class: _vm.drawerShow ? "active" : "",
                  on: { click: _vm.openTab }
                },
                [
                  _c("i", { staticClass: "el-icon-circle-plus" }),
                  _c("span", { staticClass: "word" }, [_vm._v("附属材料  ")]),
                  _c("i", {
                    class: _vm.drawerShow
                      ? "el-icon-arrow-left"
                      : "el-icon-arrow-right"
                  })
                ]
              )
            ]
          ),
          _vm.fileImgName
            ? _c(
                "div",
                {
                  staticClass: "file-img-btn",
                  on: {
                    click: function($event) {
                      _vm.fileImgShow = !_vm.fileImgShow
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.fileImgName || "") + "\n      "
                  ),
                  _c("strong", {
                    staticClass: "file-arrow",
                    class: _vm.fileImgShow
                      ? "el-icon-caret-top"
                      : "el-icon-caret-bottom"
                  })
                ]
              )
            : _vm._e(),
          _c(
            "el-main",
            { staticClass: "main-content", style: { height: _vm.boxHeight } },
            [
              _vm.showofficeEditor &&
              _vm.beWord(_vm.fileList[_vm.checkAct].fileName)
                ? _c("date-office", {
                    attrs: { editor: _vm.editor.editorConfig }
                  })
                : [
                    _c("contract-view", {
                      ref: "contractView",
                      attrs: {
                        "contract-info": _vm.currentInfo,
                        "chapter-list": _vm.chapteJson,
                        items: _vm.contractInfoTemporary.items,
                        page: _vm.currentInfo.page,
                        scaleValue: _vm.scaleValue,
                        targetId: _vm.contractInfoTemporary.targetId,
                        "show-chapter": true,
                        isDetail: true
                      },
                      on: {
                        "update:contractInfo": function($event) {
                          _vm.currentInfo = $event
                        },
                        "update:contract-info": function($event) {
                          _vm.currentInfo = $event
                        },
                        "update:chapterList": function($event) {
                          _vm.chapteJson = $event
                        },
                        "update:chapter-list": function($event) {
                          _vm.chapteJson = $event
                        },
                        "update:scaleValue": function($event) {
                          _vm.scaleValue = $event
                        },
                        "update:scale-value": function($event) {
                          _vm.scaleValue = $event
                        },
                        "pre-page": function($event) {
                          return _vm.getContractDetailByNum($event)
                        },
                        "next-page": function($event) {
                          return _vm.getContractDetailByNum($event)
                        },
                        changeSmallMap: _vm.changeSmallMap,
                        toCurrentPage: _vm.toCurrentPage
                      }
                    }),
                    _c(
                      "div",
                      { staticClass: "contract-bottom" },
                      [
                        _vm.contractInfoTemporary &&
                        _vm.contractInfoTemporary.items &&
                        _vm.contractInfoTemporary.items > 1
                          ? [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    placement: "left-start"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [_vm._v("回到首页")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "jumpFirst",
                                      on: {
                                        click: function($event) {
                                          return _vm.goPageAndFixed(1)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/images/btn-down.png")
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    placement: "left-end"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [_vm._v("回到尾页")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "jumpLast",
                                      on: {
                                        click: function($event) {
                                          return _vm.goPageAndFixed(
                                            _vm.contractInfoTemporary.items
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/images/btn-down.png")
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
            ],
            2
          ),
          _c(
            "el-aside",
            {
              staticClass: "aside-right",
              style: { height: _vm.boxHeight },
              attrs: { width: "2.80rem" }
            },
            [
              _c(
                "div",
                { staticClass: "right-bottom" },
                [
                  !_vm.isView
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.backStep }
                        },
                        [_vm._v("保存")]
                      )
                    : _c("span", { staticClass: "read-only" }, [
                        _vm._v("当前合同已完成编辑，目前只读状态")
                      ])
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请输入验证码",
            center: "",
            visible: _vm.dialogVisible,
            width: "30%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              staticStyle: { margin: "0 auto", "margin-top": "20px" },
              attrs: { inline: true, model: _vm.verifyForm, size: "small" },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.verifyCheck.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "验证码" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入验证码" },
                    model: {
                      value: _vm.verifyForm.verifyCode,
                      callback: function($$v) {
                        _vm.$set(_vm.verifyForm, "verifyCode", $$v)
                      },
                      expression: "verifyForm.verifyCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.verifyCheck }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0a41b16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0a41b16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/components/cooperateWith/reviewer.vue
// module id = 3hrF
// module chunks = 49